export const camelToUpper = (state: string) => {
    return state.replace(/([a-z])([A-Z])/g, '$1 $2').toUpperCase()
}
